// extracted by mini-css-extract-plugin
module.exports = {"icon-on-left":"button-with-icon_icon-on-left__3a6Qz","icon-on-right":"button-with-icon_icon-on-right__Ndql9"};